import { c as _c } from "react/compiler-runtime";
import Button from '@precis-digital/kurama/Button';
import Dropdown, { DropdownItem, DropdownList } from '@precis-digital/kurama/Dropdown';
import EditIcon from '@precis-digital/kurama/icons/EditIcon';
import Grid from '@precis-digital/kurama/Grid';
import MoreIcon from '@precis-digital/kurama/icons/MoreIcon';
import Notification from '@precis-digital/kurama/Notification';
import SwitchIcon from '@precis-digital/kurama/icons/SwitchIcon';
import TargetIcon from '@precis-digital/kurama/icons/TargetIcon';
import PiechartIcon from '@precis-digital/kurama/icons/PiechartIcon';
import { useState, type RefObject } from 'react';
import { useTranslation } from 'shared/translations';
export interface MoreMenuDropdownProps {
  canSwitchReports: boolean;
  handleSwitchReports: () => void;
  handleSelectTopCardMetrics: () => void;
  handleSelectConversionEvents?: () => void;
  topCardMetricsCount: number;
  conversionEventsCount?: number;
  disableConversionEvents: boolean;
  disableConversionEventsReason?: string;
  handleSelectBudgetAndTargets?: () => void;
  moreMenuButtonRef?: RefObject<HTMLButtonElement | null>;
}
const MoreMenuDropdown = t0 => {
  const $ = _c(66);
  const {
    canSwitchReports,
    handleSwitchReports,
    handleSelectTopCardMetrics,
    handleSelectConversionEvents,
    topCardMetricsCount,
    conversionEventsCount: t1,
    disableConversionEvents,
    disableConversionEventsReason,
    handleSelectBudgetAndTargets,
    moreMenuButtonRef
  } = t0;
  const conversionEventsCount = t1 === undefined ? 0 : t1;
  const {
    t
  } = useTranslation("home");
  const [dropdownAnchorEl, setDropdownAnchorEl] = useState(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = event => {
      event.stopPropagation();
      setDropdownAnchorEl(event.currentTarget);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleClick = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setDropdownAnchorEl(null);
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleClose = t3;
  const isDropdownOpen = dropdownAnchorEl != null;
  let t4;
  if ($[2] !== t) {
    t4 = t("moreMenu");
    $[2] = t;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MoreIcon />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t) {
    t6 = t("buttons.more");
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== moreMenuButtonRef || $[8] !== t4 || $[9] !== t6) {
    t7 = <Button ref={moreMenuButtonRef} fullWidth={true} variant="outlined" onClick={handleClick} aria-label={t4} rightIcon={t5}>{t6}</Button>;
    $[7] = moreMenuButtonRef;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== canSwitchReports || $[12] !== handleSwitchReports || $[13] !== t) {
    t8 = canSwitchReports && <DropdownItem onClick={() => {
      handleSwitchReports();
      handleClose();
    }} icon={<SwitchIcon />}>{t("buttons.switchReport")}</DropdownItem>;
    $[11] = canSwitchReports;
    $[12] = handleSwitchReports;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== handleSelectTopCardMetrics) {
    t9 = () => {
      handleSelectTopCardMetrics();
      handleClose();
    };
    $[15] = handleSelectTopCardMetrics;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <EditIcon />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== topCardMetricsCount) {
    t11 = topCardMetricsCount > 0 ? <Grid display="flex" alignItems="center"><Notification value={topCardMetricsCount.toString()} variant="tonal" /></Grid> : undefined;
    $[18] = topCardMetricsCount;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("buttons.selectTopCardMetrics");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12 || $[24] !== t9) {
    t13 = <DropdownItem onClick={t9} icon={t10} rightIcon={t11}>{t12}</DropdownItem>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== handleSelectConversionEvents) {
    t14 = () => {
      handleSelectConversionEvents?.();
      handleClose();
    };
    $[26] = handleSelectConversionEvents;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== disableConversionEventsReason) {
    t15 = disableConversionEventsReason != null ? {
      title: disableConversionEventsReason,
      kind: "singleline"
    } : undefined;
    $[28] = disableConversionEventsReason;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <TargetIcon />;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== conversionEventsCount) {
    t17 = conversionEventsCount > 0 ? <Grid display="flex" alignItems="center"><Notification value={conversionEventsCount.toString()} variant="tonal" /></Grid> : undefined;
    $[31] = conversionEventsCount;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== t) {
    t18 = t("dropDown.selectConversionEvents");
    $[33] = t;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== disableConversionEvents || $[36] !== t14 || $[37] !== t15 || $[38] !== t17 || $[39] !== t18) {
    t19 = <DropdownItem onClick={t14} tooltipProps={t15} icon={t16} rightIcon={t17} disabled={disableConversionEvents}>{t18}</DropdownItem>;
    $[35] = disableConversionEvents;
    $[36] = t14;
    $[37] = t15;
    $[38] = t17;
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  const t20 = disableConversionEventsReason ?? "";
  const t21 = disableConversionEventsReason == null;
  let t22;
  if ($[41] !== t20 || $[42] !== t21) {
    t22 = {
      title: t20,
      kind: "singleline",
      disabled: t21
    };
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <PiechartIcon />;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== handleSelectBudgetAndTargets) {
    t24 = () => {
      handleSelectBudgetAndTargets?.();
      handleClose();
    };
    $[45] = handleSelectBudgetAndTargets;
    $[46] = t24;
  } else {
    t24 = $[46];
  }
  let t25;
  if ($[47] !== t) {
    t25 = t("flyOut.budgetAndTargets");
    $[47] = t;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== disableConversionEvents || $[50] !== t22 || $[51] !== t24 || $[52] !== t25) {
    t26 = <DropdownItem tooltipProps={t22} disabled={disableConversionEvents} icon={t23} onClick={t24}>{t25}</DropdownItem>;
    $[49] = disableConversionEvents;
    $[50] = t22;
    $[51] = t24;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t13 || $[55] !== t19 || $[56] !== t26 || $[57] !== t8) {
    t27 = <DropdownList minWidth="300px">{t8}{t13}{t19}{t26}</DropdownList>;
    $[54] = t13;
    $[55] = t19;
    $[56] = t26;
    $[57] = t8;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== dropdownAnchorEl || $[60] !== isDropdownOpen || $[61] !== t27) {
    t28 = <Dropdown anchorEl={dropdownAnchorEl} open={isDropdownOpen} onClose={handleClose}>{t27}</Dropdown>;
    $[59] = dropdownAnchorEl;
    $[60] = isDropdownOpen;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t28 || $[64] !== t7) {
    t29 = <>{t7}{t28}</>;
    $[63] = t28;
    $[64] = t7;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  return t29;
};
export default MoreMenuDropdown;